export function redirectToLogin() {
  localStorage.removeItem("authToken");
  localStorage.removeItem("user");
  localStorage.removeItem("username");
  const jassoVerified = localStorage.getItem("jassoVerified");
  if (jassoVerified === "true" || jassoVerified === null) {
    window.location.href = process.env.REACT_APP_JBM_LOGIN_URL;
  } else {
    window.location.href = `${process.env.REACT_APP_URL}/auth/login`;
  }
}
